import { FGSelectInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGSRSHDateMaskInput } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { RequestDogOwnerList } from "../../../../pages";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";

export interface IDrupalRishRequestFormProps {
  rishRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalRishRequestForm: React.FunctionComponent<IDrupalRishRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const { user } = useAuth();

  const [dogs, dloading] = useReferential(
    (c) => c.getOwnedDogs(user.userId, initialdata?.dogId ? initialdata.dogId : 0, null, null, null),
    true,
    [initialdata, user]
  );

  return (
    <>
      <DrupalFormGenerator
        initialValues={initialdata}
        editMode={false}
        onSubmit={() => {}}
        loading={loading}
        saving={false}
        deleting={false}
        hideButtons
      >
        <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
          <div>
            <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
            {initialdata?.request?.status === ERequestState.EXECUTED && (
              <FieldGroup columns={2}>
                <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
              </FieldGroup>
            )}
            <FGSelectInput name="dogId" label={t(ETLCodes.Dog)} items={dogs} loading={dloading} />
          </div>
        </FieldGroup>
        {/* <RequestDogOwnerList dogId={initialdata.dogId} showExport={false} /> */}
        <DrupalStepperButtonBloc backOnly={true} />
      </DrupalFormGenerator>
    </>
  );
};
